import type { RouteObject } from "react-router";
import { NOTIFICATION_ROUTES } from "../constants/notification-routes";

export const notificationRoutes: RouteObject = {
	children: [
		{
			path: NOTIFICATION_ROUTES.LIST,
			lazy: async () => {
				const { default: NotificationsPage } = await import("../pages/notifications-page");
				return { Component: NotificationsPage };
			},
		},
	],
};
